import { render, staticRenderFns } from "./MyRevenueSalesChart.vue?vue&type=template&id=19dbe86d&"
import script from "./MyRevenueSalesChart.vue?vue&type=script&lang=js&"
export * from "./MyRevenueSalesChart.vue?vue&type=script&lang=js&"
import style0 from "./MyRevenueSalesChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports